export function LoadingDots({ className = '' }: { className?: string }) {
  return (
    <span className={`loading loading-dots text-neutral-600 ${className}`} />
  )
}
